/// <reference path="../../include.ts" />

namespace gpx_visualizer_phase2 {

	import View = alm.view.View;
	import Easing = alm.math.Easing;

	export class RouteEdge extends View<THREE.Object3D> {

		// --------------------------------------------------
		//
		// CONSTRUCTOR
		//
		// --------------------------------------------------

		constructor(isStart:boolean, position:THREE.Vector3) {
			super();

			this.isStart = isStart;
			this.position = position;

			this.initialize();
		}





		// --------------------------------------------------
		//
		// METHOD
		//
		// --------------------------------------------------

		protected implInitialize():THREE.Object3D {
			const view:THREE.Object3D = new THREE.Object3D();

			this.model = null;
			this.loader = new THREE.GLTFLoader();
			this.loader.load(
				'model/' + (this.isStart ? 'start' : 'goal') + '-pin.glb',
				(gltf:THREE.GLTF):void => {
					this.model = gltf.scene;
					const scale = 0.3;
					this.model.scale.set(scale, scale, scale);
					this.model.rotation.x = -Math.PI / 2;
					this.model.rotation.z = Math.PI;
					this.model.position.y = 0;

					//const color = new THREE.Color(this.isStart ? 0x1c55c8 : 0xc02721);
					const color = new THREE.Color(this.isStart ? 0x061d4b : 0x610b08);
					//const color = new THREE.Color(0x444444);
					MaterialUtil.setEmission(this.model, color);

					view.add(gltf.scene);
				},
				(event:ProgressEvent):void => {
				},
				(event:ErrorEvent):void => {
					trace('[RouteHead]', event);
				}
			);

			this.angle = 0;
			this.scale = 0;

			view.position.copy(this.position);
			view.rotation.y = this.angle;
			view.scale.set(this.scale, this.scale, this.scale);

			return view;
		}

		protected implReady():void {
		}

		protected implFinalize():void {
		}

		protected implShow(view:THREE.Object3D, useTransition:boolean):cmd.Command {
			 return new cmd.Serial(
			 	new cmd.Func(():void => {
					view.visible = true;
				}),
				new cmd.Tween(this, { scale: 1 }, null, useTransition ? 1000 : 0, Easing.easeOutQuart),
			);
		}

		protected implHide(view:THREE.Object3D, useTransition:boolean):cmd.Command {
			return new cmd.Serial(
				new cmd.Tween(this, { scale: 0 }, null, useTransition ? 1000 : 0, Easing.easeOutQuart),
				new cmd.Func(():void => {
					view.visible = false;
				}),
			);
		}

		public update():void {
			const view = this.getView();
			this.angle += 0.01;
			view.rotation.y = this.angle;
			view.scale.set(this.scale, this.scale, this.scale);
		}





		// --------------------------------------------------
		//
		// VARIABLE
		//
		// --------------------------------------------------

		private isStart:boolean;
		private loader:THREE.GLTFLoader;
		private model:THREE.Scene;
		private position:THREE.Vector3;
		private angle:number;
		private scale:number;
	}
}
